import { graphql } from "react-relay";

export const COMMIT_BUILD_RULE_CHANGES = graphql`
  mutation CommitBuildRuleChangesMutation(
    $input: CommitBuildRuleChangesInput!
  ) {
    commitBuildRuleChanges(input: $input) {
      success
    }
  }
`;
